import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { PcTabsPage } from '../pc-tabs/pc-tabs';
import { AlertController } from 'ionic-angular';
import { PartesService} from '../../services/partes.services';

@IonicPage()
@Component({
  selector: 'page-parte-detalle',
  templateUrl: 'parte-detalle.html',
})
export class ParteDetallePage {
  item = {id : null, Orden : null,Fecha : null, cuadrilla : null,idCuadrilla : 0,idEmpresa : 0, Horas : 0, Observaciones : null,Completo : null, tareas : []};
  cuadrillas = [{id:null,Nombre : null,idEmpresa : null}];
  personal = [{id : null,Nombre : null}];
  fincas = [{idFinca : null,idParcela : null, idProducto : null,Nombre : null, idEmpresa : null}];
  tareas = [{id : null,Nombre : null}];
  tarea = {idTrabajador : null,Trabajador : null,idFinca : null,idParcela : null, idProducto : null,Finca : null,idTarea : null,Tarea : null, Horas : 0, Observaciones: null};


  constructor(public navCtrl: NavController, public navParams: NavParams, public alertCtrl: AlertController, public partesService : PartesService){
    //Cargo las Cuadrillas
    partesService.getCuadrillas()
      .subscribe(cuadrillas => {
        this.cuadrillas = cuadrillas;
    });
    //Cargo las Fincas
    /*partesService.getFincas()
      .subscribe(fincas => {
        this.fincas = fincas;
    });*/
    //Cargo las Tareas
    partesService.getTareas()
      .subscribe(tareas => {
        this.tareas = tareas;
    });    
    //Si el item no es vacio, cargo el item que me pasan como parametro para edición.
    if(navParams.data.item != 0){ 
      this.item = navParams.data.item;
    }else{ 
      this.item.id = partesService.getIdParte() + 1;
      //this.item.Fecha = Date.now.toString;
    }
    //Cargo el Personal
    this.partesService.getPersonalCuadrilla(this.item.idCuadrilla)
      .subscribe(personal => {
        this.personal = personal;
    });
    //Cargo las Fincas
    partesService.getFincasEmpresa(this.item.idEmpresa)
      .subscribe(fincas => {
        this.fincas = fincas;
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ParteDetallePage');
  }

  volver(){
    this.navCtrl.setRoot(PcTabsPage);
  }

  //Devuelve id Cuadrilla dado su Nombre
  public getIdCuadrilla(strCuadrilla){
    let id = 0;
    for (let i = 0; i < this.cuadrillas.length; i++){
      if(this.cuadrillas[i].Nombre == strCuadrilla){
        id = this.cuadrillas[i].id;
      }  
    } 
    return id;
  } 
    //Devuelve id Empresa dado su Nombre
    public getIdEmpresa(strCuadrilla){
      let id = 0;
      for (let i = 0; i < this.cuadrillas.length; i++){
        if(this.cuadrillas[i].Nombre == strCuadrilla){
          id = this.cuadrillas[i].idEmpresa;
        }  
      } 
      return id;
    } 
  //Devuelve id Finca dado su Nombre
  public getFinca(strFinca){
    let finca = null;
    for (let i = 0; i < this.fincas.length; i++){
      if(this.fincas[i].Nombre == strFinca){
        finca = this.fincas[i];
      }  
    } 
    return finca;
  } 
  //Devuelve id Tarea dado su Nombre
  public getIdTarea(strTarea){
    let id = 0;
    for (let i = 0; i < this.tareas.length; i++){
      if(this.tareas[i].Nombre == strTarea){
        id = this.tareas[i].id;
      }  
    } 
    return id;
  } 
  //Devuelve id Trabajador dado su Nombre
  public getIdTrabajador(strTrabajador){
    let id = 0;
    for (let i = 0; i < this.personal.length; i++){
      if(this.personal[i].Nombre == strTrabajador){
        id = this.personal[i].id;
      }  
    } 
    return id;
  }   

  //Devuelve el numero de Unidades de las lineas de un Parte
  public countHoras(){
    let Horas = parseFloat("0");
    let strhoras = "0";
    for (let i = 0; i < this.item.tareas.length; i++){
      strhoras = this.item.tareas[i].Horas;
      if (strhoras == "0"){
        strhoras = "0";
      }
      strhoras = strhoras.replace("'",".");
      this.item.tareas[i].Horas = strhoras.replace(",",".");
      Horas = Horas + parseFloat(this.item.tareas[i].Horas);
    }
    return Horas;
  }  

  //Añadir Parte
  addParte(){
    let finca : {idFinca : null,idParcela : null, idProducto : null,Nombre : null};
    if (this.item.tareas.length <= 0){alert("Debes de asignar al menos una tarea al Parte de Trabajo.");}
    else{
	  this.item.Completo = "COMPLETO";
      for (let j= 0; j < this.item.tareas.length; j++){
        finca = this.getFinca(this.item.tareas[j].Finca);
        if (finca != null){
          this.item.tareas[j].idFinca = finca.idFinca;
          this.item.tareas[j].idParcela = finca.idParcela;
          this.item.tareas[j].idProducto = finca.idProducto;            
        }
        this.item.tareas[j].idTarea = this.getIdTarea(this.item.tareas[j].Tarea);
        this.item.tareas[j].idTrabajador = this.getIdTrabajador(this.item.tareas[j].Trabajador);

        //alert('TAREA: ' + this.item.tareas[j].idTarea  + ' FINCA: ' + this.item.tareas[j].idFinca + ' TRABAJADOR: ' + this.item.tareas[j].idTrabajador);
        if (this.item.tareas[j].idFinca == null || this.item.tareas[j].idTarea == 0 || this.item.tareas[j].idTrabajador == 0 || this.item.tareas[j].Horas == 0){
          this.item.Completo = "INCOMPLETO";
        }		
      }
      this.item.Horas = this.countHoras();
      this.item.Orden = 1000000 - this.item.id;
      this.partesService.editParte(this.item);
      this.navCtrl.pop();
    }
  } 

  //Borrar Tarea
  deleteTarea(tarea){

    let alert = this.alertCtrl.create({
      title: 'Confirmar borrado',
      message: '¿Estás seguro de que deseas eliminar esta Tarea?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {
          // Ha respondido que no así que no hacemos nada
          }
        },
        {
          text: 'Si',
          handler: () => {
               // Aquí borramos el sitio en la base de datos
               for (let j= 0; j < this.item.tareas.length; j++){
                if(this.item.tareas[j] == tarea){
                  this.item.tareas.splice(j, 1);
                }
              }
           }
        }
      ]
    });
    alert.present();
  }

  //Borrar PArte
  deleteParte(){
    let alert = this.alertCtrl.create({
      title: 'Confirmar borrado',
      message: '¿Estás seguro de que deseas eliminar este Parte?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {
            // Ha respondido que no así que no hacemos nada
          }
        },
        {
          text: 'Si',
          handler: () => {
               // Aquí borramos el sitio en la base de datos
               this.partesService.deleteParte(this.item);
               this.navCtrl.pop();
           }
        }
      ]
    });
    alert.present();
  }  

  //Añadir una Tarea a Parte Trabajo
  addTarea(){
    
    if (this.item.cuadrilla == null) {
      alert("Debe seleccionar una Cuadrilla");
    }
    else if (this.item.Fecha == null) {
      alert("Debe seleccionar una Fecha");
    }
    else
    { //En la primera tarea completo idCuadrilla, idEmpresa y cargo el personal de la cuadrilla en el Combo.
      if (this.item.tareas.length == 0)
      {
        this.item.idCuadrilla = this.getIdCuadrilla(this.item.cuadrilla);
        this.item.idEmpresa = this.getIdEmpresa(this.item.cuadrilla);

        //Cargo el Personal
        this.partesService.getPersonalCuadrilla(this.item.idCuadrilla)
          .subscribe(personal => {
            this.personal = personal;
        });
        //Cargo las Fincas
        this.partesService.getFincasEmpresa(this.item.idEmpresa)
          .subscribe(fincas => {
            this.fincas = fincas;
        });        
      }
      this.tarea.idFinca = "";
      this.tarea.idParcela = "";
      this.tarea.idProducto = "";
      this.tarea.Horas  = 0;
      this.tarea.Tarea = "";
      this.tarea.Trabajador = "";
      this.tarea.Observaciones = "";
      this.item.tareas.push(this.tarea);
      this.tarea = {idTrabajador : null,Trabajador : null,idFinca : null,idParcela : null,idProducto : null,Finca : null,idTarea : null,Tarea : null, Horas : 0, Observaciones : null};
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/parte-detalle/parte-detalle.ts